export const URL = {
  signin: '/signin',
  employees: '/employees',
  phones: '/phones',
  actPlan: '/',
  plan: '/plan',
  profile: '/profile',
  departments: '/departments',
  styles: '/styles',
  statuses: '/statuses',
  announces: '/announces',
  myGroups: '/my-groups',
  myGroupDetail: '/mygroupdetail',
  employeeMyGroups: '/employee-my-groups',
  company: '/company',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  historyExport: '/history-export',
  prefectures: '/prefectures',
  tenants: '/tenants',
  homePage: '/home',
  privacy: '/home/privacy',
  sct: '/home/sct',
  overview: '/home/overview',
};

export default URL;
